var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{attrs:{"title":'Tambah Apoteker'},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('HrForm')]},proxy:true}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }